/* src/app/components/terminals/terminals-default/terminals-default.component.css */
/*# sourceMappingURL=terminals-default.component-O2UTUH2W.css.map */
